import { Link, useLocation } from 'react-router-dom';
import ArrowLeft from '../../Assets/Arrow left.svg';
// import ProductBar from './Components/ProductBar';
import ProductStats from './Components/ProductStats';
import PriceHistoryGraph from './Components/PriceHistory.Graph';
import { conversionRate, netRevenue, priceHistory, returnRatio, reviews } from './ChartData';
import SalesGeneratedGraph from './Components/SalesGenerated.Graph';
import ConversionRateGraph from './Components/ConversionRate.Graph';
import ReturnRatioGraph from './Components/ReturnRatio.Graph';
import ReviewsGraph from './Components/Reviews.Graph';
import NetRevenueGraph from './Components/NetRevenue.Graph';

import ChevronDown from '../../Assets/Dropdown/ChevronDown.svg';

function ProductStatsAndInsightPage() {
    const location = useLocation();

    return (
        <div className="w-full overflow-y-scroll pb-16">
            <div className="flex items-center justify-between gap-6 relative m-[20px_19px_24px_20px]">
                <div className="w-fit flex items-center">
                    <Link to={`${location.pathname.split('/').slice(0, -1).join('/')}`} className="img p-[10px] flex items-center justify-center">
                        <img className='w-6 h-6 text-[#666666]' src={ArrowLeft} alt="" />
                    </Link>

                    <h1 className="p-[6px] text-[#121212] font-urbanist-regular font-bold leading-8 text-[24px]">Product Name</h1>
                </div>

                <button onClick={() => {}} className="cursor-pointer rounded-md border border-[#EAEAEA] p-[10px_2px_10px_8px] flex items-center gap-1">
                    <p className='w-20 font-semibold font-urbanist-regular text-[14px] leading-[22px] text-[#121212] text-left'>All Time</p>

                    <div className="w-[22px] h-[22px] flex items-center justify-center">
                        <img src={ChevronDown} alt="" />
                    </div>
                </button>
            </div>

            {/* <ProductBar /> */}

            {/* Product Stats */}
            <ProductStats />

            {/* Price History Graph for Product */}
            <div className="flex mt-3 mx-5">
                <PriceHistoryGraph 
                    priceHistoryData={priceHistory} 
                />
            </div>

            {/* Sales Generated Graph for Product */}
            <div className="flex mt-3 mx-5">
                <SalesGeneratedGraph />
            </div>

            {/* Conversion Rate and Return Ratio Graph */}
            <div className="grid grid-cols-3 mt-3 mx-5 gap-x-2">
                <ConversionRateGraph 
                    conversionRateData={conversionRate} 
                />

                <ReturnRatioGraph 
                    returnRatioData={returnRatio} 
                />
            </div>

            {/* Reviews Graph */}
            <div className="flex mt-3 mx-5">
                <ReviewsGraph 
                    reviewsData={reviews} 
                />
            </div>

            {/* Net Revenue Graph */}
            <div className="flex mt-3 mx-5">
                <NetRevenueGraph 
                    netRevenueData={netRevenue} 
                />
            </div>
        </div>
    );
}

export default ProductStatsAndInsightPage;
